import { render, staticRenderFns } from "./AssignDeviceHistory.vue?vue&type=template&id=dbff376a&scoped=true"
import script from "./AssignDeviceHistory.vue?vue&type=script&lang=js"
export * from "./AssignDeviceHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbff376a",
  null
  
)

export default component.exports